var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"work-page"}},[_c('div',{staticClass:"title"},[_c('textCode',{attrs:{"text":"h1"}}),_c('textHeader',{attrs:{"text":"My Project","close":"true"}})],1),_c('div',{staticClass:"work-list"},_vm._l((_vm.reports),function(work,index){return _c('workItem',{key:index,attrs:{"work":work,"index":index}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }